import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { Subscription } from 'src/app/_models/subscription';
import { AuthService } from 'src/app/_services/auth.service';
import { StudentService } from 'src/app/_services/student.service';
import Swal from 'sweetalert2';
import { QuizService } from './../../../_services/quiz.service';

@Component({
  selector: 'app-pending-quiz-list',
  templateUrl: './pending-quiz-list.component.html',
  styleUrls: ['./pending-quiz-list.component.css']
})
export class PendingQuizListComponent implements OnInit {
  @Input() data: any=undefined
  @Input() server_student_user_id=0
  @Input() quiz_mode_name:string
  loading=false
  showQuizItems = false
  loadingEnvelops=false
  hasEnrollments = false
  isPremium= false
  server_enrolment_id=0
  subscription = new Subscription()
  subscriptionId = 0
  pendingQuizEnvelops = undefined
  imageSource:any
  downloading=0
  maxOpenSubjectQuiz = 0
  maxOpenQuizNoAlert = 0
  allQuizCount = 0
  learner:any=undefined
  dtOptions: DataTables.Settings={}
  constructor(
    public authService: AuthService,
    private studentService: StudentService,
    private quizService:QuizService,
    private activatedRoute:ActivatedRoute,
    private router: Router) { }

  ngOnInit(): void {
    this.dtOptions = {paging: false,ordering: false,info: false}
    this.loadingEnvelops=true
    this.studentService.minStudentData.subscribe(
      learner=>{
        this.learner=learner
        this.server_student_user_id=this.learner.server_student_user_id
      }
    )
    this.initParams()

  }
  initParams(){
    this.activatedRoute.params.subscribe(
      params=>{
        this.server_student_user_id=params['server_student_user_id']
        this.initPendingQuiz()
      }
    )
  }
  initPendingQuiz(){
    this.loadingEnvelops=true
    if(this.data){
        this.maxOpenSubjectQuiz = this.data['maxOpenSubjectQuiz']
        this.maxOpenQuizNoAlert = this.data['maxOpenQuizNoAlert']
        this.pendingQuizEnvelops = this.data['pendingQuizEnvelops']
        this.loadingEnvelops=false
        this.subscription = this.data['subscription_object']
        this.server_enrolment_id = this.data['currentEnrolment'] ? this.data['currentEnrolment'].server_enrolment_id:0
        if (this.data['subscription_object'] != null) {
          this.isPremium = this.subscription['is_premium_subscription_type']==1
          this.subscriptionId = this.subscription['server_subscription_id']
        }

    }
  }

downloadPdf(quizEnvelopId:number){
  this.loading=true
  this.downloading=quizEnvelopId
  this.studentService.getWorksheet(quizEnvelopId).subscribe({
    next:(data:ResultData)=>{
      this.imageSource= `data:application/pdf;base64,${data.rs.data}`
      this.downloadMyPdf(quizEnvelopId)
  }
    })
}

downloadMyPdf(quizEnvelopId:number) {



   const link = document.createElement("a");
   let fileName= "boldungu_quiz_"+quizEnvelopId+"_"+Date.now()
   link.href = this.imageSource;
   link.download = `${fileName}.pdf`
   this.loading=false
   link.click();

 }

 deleteQuiz(server_quiz_envelop_id:number){
    this.quizService.deleteQuiz(server_quiz_envelop_id).subscribe(
      myR=>{

        this.router.navigate(["/student/quiz/pending",this.server_student_user_id,this.quiz_mode_name])
      }
    )

 }
 trialAlertPendingMaxAlert() {
  this.trialAlertPendingMaxAlertMe(
    this.pendingQuizEnvelops,
    this.maxOpenSubjectQuiz,
    this.router, this.isPremium,
    this.allQuizCount,
    this.maxOpenQuizNoAlert,
    this.server_student_user_id,
    this.subscriptionId,
    this.quiz_mode_name

  )

}

trialAlertPendingMaxAlertMe(pendingQuizEnvelops:any,maxOpenSubjectQuiz:number,router:Router,isPremium:boolean,allQuizCount:number,maxOpenQuizNoAlert:number,serverStudentUserId:number,subscriptionId:number,quiz_mode_name:string){
let n = pendingQuizEnvelops.length
if(n >= maxOpenSubjectQuiz){
  var message ="Please first answer the  "+n+ " unanswered quiz!"
  Swal.fire( 'Oops',message,'info')
 }else if(!isPremium){
 if(allQuizCount > maxOpenQuizNoAlert){
   this.showOpenAlert(router,serverStudentUserId,subscriptionId)
 }else{
  router.navigate(['student/quiz/new',serverStudentUserId,subscriptionId,quiz_mode_name])
 }
}else{
router.navigate(['student/quiz/new',serverStudentUserId,subscriptionId,quiz_mode_name])
}

}
 showOpenAlert(router:Router,serverStudentUserId:number,subscriptionId:number){
  Swal.fire({
  title: '<strong>Free Trial Service</strong>',
  icon: 'info',
  html: 'Just to let you know that this is a Free Trial Service. Some topics will be crossed out. You can only create quiz for some of the topics. You need to upgrade to premium to enjoy unlimited access',
  showCloseButton: true,
  showCancelButton: true,
  allowOutsideClick: false,
  focusConfirm: true,
  confirmButtonText:'<i class="fa fa-thumbs-up"></i> Up grade to Premium',
  confirmButtonAriaLabel: 'Thumbs up, great!',
  cancelButtonText:'<i class="fa fa-thumbs-up"></i> Continue to Create Quiz',
  cancelButtonAriaLabel: 'Thumbs up'
}).then((result) => {
  if (result.value) {

  }else if(result.dismiss === Swal.DismissReason.close){
    ;
  }else{
    router.navigate(['student/quiz/new',serverStudentUserId,subscriptionId])
  }
})

}
}
